import { useRef, useState } from "react";

import { TInputTag } from "components/InputMultipleTag";

import { queryGetUserAssociatedCorpList } from "@type/api/corporation";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

interface UseGetCorporationListProps {
  enabled?: boolean;
}

export const useGetCorporationList = ({
  enabled,
}: UseGetCorporationListProps) => {
  const procesedPage = useRef<number[]>([]);
  const [page, setPage] = useState(1);
  const [corporationOptions, setCorporationOptions] = useState<TInputTag[]>([]);

  const { isLoading } = useQueryWithCallbacks({
    queryKey: queryGetUserAssociatedCorpList._key({
      page: page,
      pageSize: 20,
    }),
    enabled: enabled && page > 0,
    queryFn: () => queryGetUserAssociatedCorpList({ page: page, pageSize: 20 }),
    onSuccess: (res) => {
      if (!procesedPage.current.includes(res.page)) {
        setCorporationOptions((prev) => {
          const newData: TInputTag[] = res.data.map((corp) => ({
            id: corp.idUnique,
            name: corp.name,
            image: corp?.profilePicture,
          }));

          if (res.page === 1) {
            return newData;
          }

          return [...prev, ...newData];
        });

        if (res.page * res.pageSize < res.total) {
          setPage(res.page + 1);
        }
        procesedPage.current = [...procesedPage.current, res.page];
      }
    },
  });

  return {
    isLoadingCorporationOptions: isLoading,
    corporationOptions,
  };
};
